import { commonStore } from './common'
import { mainStore } from './main'
import { pageScrollStore } from './page-scroll'
import { windowStore } from './window'

export const stores = (gaApp) => {
  return {
    main: mainStore(gaApp),
    common: commonStore(gaApp),
    pageScroll: pageScrollStore(gaApp),
    window: windowStore(gaApp),
  }
}
